// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

interface SelectVariantFromImages {
    variantId: string;
    productInfo: ProductInfo;
}

const useSetSelectedVariant = () => {
    const dispatch = useAppDispatch();
    const setSelectedVariant = (selectedVariant: SelectVariantFromImages) => {
        const { variantId, productInfo } = selectedVariant;
        dispatch({
            type: "Pages/ProductDetails/UpdateVariantSelection",
            variantSelection: variantId,
            variantSelectionCompleted: true,
            selectedProductInfo: productInfo,
        });
    };
    return setSelectedVariant;
};
export default useSetSelectedVariant;
